import '.fd{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fe{padding-left:1.5rem;}.ssr-plugin'
import '.ff{margin:1rem 0;}.ssr-plugin'
import '.fg{color:var(--gray-700);}.ssr-plugin'
import '.fh{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fd fe ff fg fh"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
